/**
 * Original regex had issues with long email addresses due to Catastrophic Backtracking (theory).
 * Switching to this one, which I tested out: https://regexr.com/2rhq7
 */
const _emailRegex = new RegExp(
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
);

const validEmail = (candidateEmail: string): boolean =>
  _emailRegex.test(candidateEmail.toLowerCase());
export default validEmail;
